import React from 'react';
import { Table, Button } from 'antd';
import type { PricePlan } from '../../../types/pricePlans';

interface PricePlansTableProps {
  pricePlans: PricePlan[];
  loading: boolean;
  pagination: any;
  onEdit: (plan: PricePlan) => void;
  onView: (plan: PricePlan) => void;
  onTableChange: (pagination: any) => void;
}

const PricePlansTable: React.FC<PricePlansTableProps> = ({ pricePlans, loading, pagination, onEdit, onView, onTableChange }) => {
  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Description', dataIndex: 'description', key: 'description' },
    { title: 'Monthly Value', dataIndex: 'monthly_value', key: 'monthly_value' },
    { title: 'Max Units', dataIndex: 'max_units', key: 'max_units' },
    { title: 'Max Employees', dataIndex: 'max_employees', key: 'max_employees' },
    { title: 'Max Users', dataIndex: 'max_users', key: 'max_users' },
    { title: 'Type', dataIndex: 'is_custom', key: 'is_custom', render: (isCustom: boolean) => isCustom ? 'Custom' : 'Standard' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: PricePlan) => (
        <>
          <Button type="link" onClick={() => onView(record)}>View</Button>
          <Button type="link" onClick={() => onEdit(record)}>Edit</Button>
        </>
      ),
    },
  ];
  return (
    <Table
      columns={columns}
      dataSource={pricePlans}
      loading={loading}
      pagination={pagination}
      rowKey="id"
      onChange={onTableChange}
    />
  );
};

export default PricePlansTable; 